import Tesseract from "tesseract.js";
import * as pdfjsLib from "pdfjs-dist/webpack";
import notFoundImg from '../../assets/img/not_found/image_not_found.png';

export const getToken = (navigate, toast) => {
  const token = localStorage.getItem("token");
  if (!token) {
    navigate("/auth-signin");
    return;
  }
  return token;
};

export const getUser = () => {
  const user = localStorage.getItem("yobasUser");
  if (user) {
    return JSON.parse(user);
  }
};

export const getUserRole = () => {
  const role = localStorage.getItem("yobas_role");
  if (role) {
    return JSON.parse(role);
  }
};

/**
 * Make error message from API response
*/
export const makeError = (error, toast) => {
  if (!toast || typeof toast.error !== "function") return;

  const errors = error?.response?.data?.errors;
  const message = error?.response?.data?.message;

  // Laravel / validation errors
  if (errors && typeof errors === "object") {
    Object.keys(errors).forEach((key) => {
      const messages = Array.isArray(errors[key]) ? errors[key] : [errors[key]];
      messages.forEach((msg) => {
        toast.error(msg, { autoClose: 3000 });
      });
    });
    return;
  }

  // Single API message
  if (typeof message === "string" && message.trim() !== "") {
    toast.error(message, { autoClose: 3000 });
    return;
  }

  // Fallback error
  toast.error("Internal Server Error. Please try again.", { autoClose: 3000 });
};

/**
 * Extract text from a PDF File
 */
export const extractTextFromPDF = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = async () => {
      try {
        const typedArray = new Uint8Array(reader.result);
        const pdf = await pdfjsLib.getDocument(typedArray).promise;

        let fullText = "";

        for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
          const page = await pdf.getPage(pageNum);
          const textContent = await page.getTextContent();
          const pageText = textContent.items.map((item) => item.str).join(" ");
          fullText += pageText + "\n";
        }

        resolve(fullText);
      } catch (error) {
        reject(error);
      }
    };

    reader.readAsArrayBuffer(file);
  });
};

/**
 * Extract text from an Image File
 */
export const extractTextFromImage = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = async () => {
      try {
        const imgData = reader.result;

        const result = await Tesseract.recognize(imgData, "eng", {
          logger: (m) => console.log(m),
        });

        resolve(result.data.text);
      } catch (error) {
        reject(error);
      }
    };

    reader.readAsDataURL(file);
  });
};

/**
 * format date to 2026/01/01
*/
export const formatYYYYMMDD = (dateString) => {
  const date = new Date(dateString);
  return date.toISOString().split("T")[0];
}

/**
 * get today date
*/
export const getTodayDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

/**
 * showImage by path if path is not available then show static image
*/
export const showImage = (url) => {
  if(!url){
    return notFoundImg;
  }
  return url
};
